import { render, staticRenderFns } from "./viewBom.vue?vue&type=template&id=67a951cf&scoped=true&"
import script from "./viewBom.vue?vue&type=script&lang=ts&"
export * from "./viewBom.vue?vue&type=script&lang=ts&"
import style0 from "./viewBom.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./viewBom.vue?vue&type=style&index=1&id=67a951cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a951cf",
  null
  
)

export default component.exports